import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { bound } from 'Helpers/Utils';

const styles = theme => ({
  root: {
    position: 'absolute',
    transform: 'scale(1) translate(-50%, -105%)',
    width: 'fit-content',
  },
  progressIndicator: {
    display: 'flex',
    justifyContent: 'center',
  },
  progressIndicatorComplete: {
    justifyContent: 'flex-end',
  },
  progressIndicatorInner: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 'fit-content',
  },
  progressIndicatorInnerComplete: {
    alignItems: 'flex-end',
  },
  progressPercent: {
    color: theme.palette.facet.accentGreen,
    fontSize: theme.typography.h1.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
  },
  progressBarComplete: {
    background: `transparent linear-gradient(90deg, ${theme.palette.facet.accentBlue} 0%, ${theme.palette.facet.accentGreen} 100%) 0% 0% no-repeat padding-box;`,
  },
  progressLabel: {
    color: theme.palette.facet.primaryGray,
    fontWeight: theme.typography.fontWeightBold,
    whiteSpace: 'nowrap',
    fontSize: theme.typography.body1.fontSize,
  },
  progressTriangle: {
    width: 0,
    height: 0,
    borderStyle: 'solid',
    borderWidth: '15px 7.5px 0 7.5px',
    borderColor: `${theme.palette.facet.accentGreen} transparent transparent transparent`,
  },
});

const ProgressSliderValue = (props) => {
  const { value, classes } = props;
  const completed = value >= 100;

  let left;

  if (completed) {
    left = 'calc(100% - 115px)';
  } else {
    left = `${bound(1, 100)(value)}%`;
  }

  return (
    <div className={classes.root} style={{ left }}>
      <div className={classNames({
        [classes.progressIndicator]: true,
        [classes.progressIndicatorComplete]: completed,
      })}
      >
        <div className={classNames({
          [classes.progressIndicatorInner]: true,
          [classes.progressIndicatorInnerComplete]: completed,
        })}
        >
          <div className={classes.progressLabel}>Progress</div>
          <div className={classes.progressPercent}>{value}% {completed && 'Congrats!'}</div>
          <div className={classes.progressTriangle} />
        </div>
      </div>
    </div>
  );
};

ProgressSliderValue.propTypes = {
  value: PropTypes.number.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ProgressSliderValue);
